import client from "../client";

export const updatePrebidFiles  = async () => {
  const res = await client.get(`ascendeum/update-prebid-files`);
  return res.data;
};